import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3a532a38&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3a532a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a532a38",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterSocialIcon: require('/opt/build/repo/components/storyblok/FooterSocialIcon.vue').default})
